import { Routes } from '@angular/router';

/**
 * Lazy route → legacy stub page. Production UX: `RequestPhysicalCollectionOverlayService` + `V2RequestPhysicalCollectionComponent`.
 * Remove when deeplink is dropped. Full old source: `legacy-reference/*.legacy-reference.txt`.
 */
export const requestPhysicalCollectionRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./request-physical-collection.page').then(
        (m) => m.RequestPhysicalCollectionPage
      ),
  },
];
